goog.provide('el8.ptdata.rxHistoryDownloadSummaries');

goog.require('el8.model.base');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.ptdata.medOrderFills');
goog.require('el8.ptdata.model.medOrderFill');
goog.require('el8.template.ptdata.rxHistoryDownloadSummaries');
goog.require('el8.data.referencedUsers');

el8.ptdata.rxHistoryDownloadSummaries = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.fills) {
            spec.fill_ids = spec.fills.map(function(a) {
                var fill = el8.ptdata.medOrderFills.create(a, true);
                return fill.getId();
            });
        }
        this.parent.populate.call(this, spec);
    };
    _class.addProperty('fillIds');
    _class.addIntProperty('downloadedFillsCount');

    _class.addStringProperty('eligPbmName');
    _class.addStringProperty('eligPatientFullName');
    _class.addStringProperty('eligPatientSex');
    _class.addDate('eligPatientDob');

    _class.prototype.getFills = function() {
        return this.getFillIds().map(function(id) {
            return el8.ptdata.medOrderFills.getById(id);
        });
    };

    _class.prototype.getUnsignedFills = function() {
        return this.getFills().filter(function(a) { return a.isRxDownload(); });
    };

    _class.prototype.getUnsignedMeds = function() {
        var fills = this.getFills();
        var threadIds = [], orderIds = [];
        for (var i=0; i<fills.length; i++) {
            if (fills[i] && fills[i].isRxDownload()) {
                if (fills[i].getThreadId()) {
                    threadIds.push(fills[i].getThreadId());
                }
                if (fills[i].getMedOrderId()) {
                    orderIds.push(fills[i].getMedOrderId());
                }
            }
        }
        return {
            threadIds: threadIds,
            orderIds: orderIds
        };
    };

    _class.prototype.removeFillId = function(fillId) {
        var oldFillIds = this.getFillIds();
        var newFillIds = [];
        for (var i=0; i<oldFillIds.length; i++) {
            if (oldFillIds[i] !== (fillId*1)) {
                newFillIds.push(oldFillIds[i]);
            }
        }
        this.setFillIds(newFillIds);
    };

    _class.prototype.hasFillId = function(fillId) {
        var allFillIds = this.getFillIds();
        for (var i=0; i<allFillIds.length; i++) {
            if (allFillIds[i] === fillId) { return true; }
        }
        return false;
    };

    _class.prototype.getDownloadedFillById = function(fillId) {
        var downloadedFills = this.fetchDownloadedFills();
        var match = _.find(downloadedFills, function(f) { return f.getId() === fillId; });
        return match || null;
    };

    _class.prototype.fetchDownloadedFills = function(force) {
        /* Fetch once; else if cached, just return cached data */
        if (force || !this._downloadedFills) {
            var that = this;
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('rxSummaryDownloadedFills', [this.getId()]),
                async: false,
                success: function(data) {
                    /* Convert JSON into fill objects, but DO NOT add to el8.ptdata.medOrderFills
                     * cache because these are technically deleted, and only the rx summary cares
                     * about it for display in the details case */
                    that._downloadedFills = data.map(el8.ptdata.model.medOrderFill);
                }
            });
        }
        return this._downloadedFills;
    };

    _class.prototype.getReconciledFillsCount = function() {
        var downloadedFills = this.fetchDownloadedFills();
        var reconciledFills = _.filter(downloadedFills, function(f) { return !f.isRxDownload(); });
        return reconciledFills.length;
    };

    _class.prototype.getDescription = function() {
        // don't forget this is escaped
        return el8.template.ptdata.rxHistoryDownloadSummaries.description({
            fillsCount: this.getDownloadedFillsCount(),
            eligPbmName: this.getEligPbmName(),
            eligPatientFullName: this.getEligPatientFullName(),
            eligPatientSex: this.getEligPatientSex(),
            eligPatientDob: el8.service.tz.soyStr(this.getEligPatientDob())
        });
    };

    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.rxHistoryDownloadSummaries.noteSummary({
            chartFeedDate: this.isSignedOff() ? el8.service.tz.soyStr(this.getSignDate()) :
                el8.service.tz.soyStr(this.getChartFeedDate())
        }).el8_unescape();
    };

    _class.prototype.asSoyMap = function() {
        var NUM_LATEST = 10;
        var latestFills = this.isSignedOff() ? this.getFills() : this.getUnsignedFills();
        var m = {
            id: this.getId(),
            description: this.getDescription(),
            numMore: (latestFills.length > NUM_LATEST) ?
                (latestFills.length - NUM_LATEST) : 0,
            isSigned: this.isSignedOff(),
            eligPbmName: this.getEligPbmName()
        };
        if (this.isSignedOff()) {
            m['signUserName'] = this.getSignUserName();
            m['signUserBehalfName'] = this.getSignUserBehalfName();
            m['signDate'] = el8.service.tz.soyStr(this.getSignDate());
        }
        return m;
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            el8.appservice.notifier.notify('Deleting Rx History Downlaod...');
            $.el8_ajax({
                type: "DELETE",
                url: el8.service.urls.get('deleteDocument', [item]),
                async: (opts.async !== false), // defaults to true
                success: function(data) {
                    if (successCb) { successCb(); }
                    el8.appservice.notifier.notify('Rx History Download deleted.');
                },
                error: errorCb
            });
        }
    });

    that.getAllUnsignedMeds = function() {
        var threadIds = [], orderIds = [];
        that.all().map(function(summary) {
            var unsignedMeds = summary.getUnsignedMeds();
            threadIds.addArray(unsignedMeds['threadIds']);
            orderIds.addArray(unsignedMeds['orderIds']);
        });
        return {
            threadIds: threadIds,
            orderIds: orderIds
        };
    };

    that.getSummaryByFillId = function(fillId) {
        var all = that.all();
        for (var i=0; i<all.length; i++) {
            if (all[i].hasFillId(fillId)) {
                return all[i];
            }
        }
        return null;
    };

    return that;

})();


